import React from "react";
import BirthdayPackagesPage from "../BirthdayPackagesPage/BirthdayPackagesPage";

const MyMaorPackages = () => <BirthdayPackagesPage />;

export default MyMaorPackages;
